import { render, staticRenderFns } from "./JobsOverviewTable.vue?vue&type=template&id=2f3612c6&scoped=true&"
import script from "./JobsOverviewTable.vue?vue&type=script&lang=js&"
export * from "./JobsOverviewTable.vue?vue&type=script&lang=js&"
import style0 from "./JobsOverviewTable.vue?vue&type=style&index=0&id=2f3612c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3612c6",
  null
  
)

export default component.exports